import * as React from "react";
const SvgHeart = props => <svg viewBox="0 0 44 44" {...props}><path d="m21.8 42.7 18-17.9A13.4 13.4 0 0 0 21.7 5 13.4 13.4 0 0 0 4 25z" /></svg>;
export default SvgHeart;